import React, { ComponentProps, useCallback } from 'react';

import { ActivityCard } from '@adsk/alloy-react-activity-log';

import PlanTaskEntityActivityCardDetails from './PlanTaskEntityActivityCardDetails/PlanTaskEntityActivityCardDetails';
import PlanTaskEntityActivityCardFooter from './PlanTaskEntityActivityCardFooter/PlanTaskEntityActivityCardFooter';
import { ACTIVITY_VARIANTS } from '../../../../constants';
import { useTaskLocale } from '../../hooks';
import { TaskEntity } from '../../types';

type PlanTaskEntityActivityCardProps = ComponentProps<typeof ActivityCard> & {
  entity: TaskEntity;
  variant?: typeof ACTIVITY_VARIANTS.ADDED | typeof ACTIVITY_VARIANTS.REMOVED;
};

const PlanTaskEntityActivityCard = ({
  entity: { task },
  variant,
  ...rest
}: PlanTaskEntityActivityCardProps) => {
  const { t } = useTaskLocale();

  const title =
    variant === ACTIVITY_VARIANTS.REMOVED
      ? t('PLAN_TASK_REMOVED')
      : t('PLAN_TASK_ADDED');

  const renderFooter = useCallback(
    (props: ComponentProps<typeof ActivityCard.Footer>) => (
      <PlanTaskEntityActivityCardFooter {...props} />
    ),
    [],
  );

  return (
    <ActivityCard {...rest} title={title} renderFooter={renderFooter}>
      {task && (
        <PlanTaskEntityActivityCardDetails task={task} variant={variant} />
      )}
    </ActivityCard>
  );
};

export default PlanTaskEntityActivityCard;
